import { morph as morphElement } from "web-ui/morphdom/morph"

function morph() {
  const childrenOnly = this.hasAttribute("children-only")

  this.targetElements.forEach(targetElement => {
    const fromElement = targetElement
    let toElement

    if (childrenOnly) {
      toElement = this.templateContent
    } else {
      toElement = this.templateElement.innerHTML
    }

    morphElement(fromElement, toElement, { childrenOnly })
  })
}

export function activate(Turbo) {
  Turbo.StreamActions.morph = morph
}
